import { NcwOnboardingSlideThree } from '@capsicum/common';
import { Button } from '@capsicum/common-web';
import { type SlideProps } from '@capsicum/features/nc-onboarding/shared';
import styled from 'styled-components';

import { useOnboardingSlidesTranslations } from '../../../hooks/onboarding/useOnboardingSlidesTranslations';
import { Shell } from '../../shell';
import { Description, Title } from '../Page.styled';

export const ThirdSlide = ({ onNextSlide }: SlideProps) => {
	const $t = useOnboardingSlidesTranslations();

	return (
		<Shell
			cta={<Button testID="ncOnboarding-next-button" text={$t('ncOnboard.actions.next')} onClick={onNextSlide} />}
			image={NcwOnboardingSlideThree}
		>
			<S.Content>
				<S.Details>
					<Title color="onDark.enabled" variant="display2">
						{$t('ncOnboard.thirdSlide.title')}
					</Title>

					<Description color="onDark.enabled" variant="text2">
						{$t('ncOnboard.thirdSlide.description')}
					</Description>
				</S.Details>
			</S.Content>
		</Shell>
	);
};

namespace S {
	export const Content = styled.div`
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxlarge};
	`;

	export const Details = styled.div`
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
	`;
}
